import React, { useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';
import { CancelToken } from 'axios';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const BillingAccountDelete = props => {
    let { classes, billDeliveryNoteModalState, id, billDeliveryNote, handleDeliveryNoteBill, activeCustomer, translations } = props;

    const billCancel = CancelToken?.source();
    const handleCloseSafe = () => {
        handleDeliveryNoteBill();
    };

    const handleCloseDanger = async () => {
        await billDeliveryNote({ DeliveryNoteID: id, ActiveCustomerID: activeCustomer }, { cancelToken: billCancel });
        handleDeliveryNoteBill();
    };
    useEffect(() => {
        return () => {
            billCancel.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Dialog
            open={billDeliveryNoteModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{translations['charge_delivery_note'] || 'Charge Delivery Note'}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {translations['charge_careful'] || "Be careful when charging delivery note"}.<br />
                    {translations['sure_delivery'] || 'Are you sure that this delivery note is charged'}?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    {translations['no'] || 'No'}
                </Button>
                <Button onClick={handleCloseDanger} variant="contained" className={classes.buttonDanger}>
                    {translations['yes'] || 'Yes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default withStyles(styles, { withTheme: true })(BillingAccountDelete);